import Icon      from 'components/Icon/Icon.react';
import PropTypes from 'prop-types';
import React     from 'react';
import styles    from 'components/MultiSelectIcons/MultiSelectIcons.scss';

export default class MultiSelectIconsOption extends React.Component {
  constructor() {
    super();
  }

  render() {
    let classes = [styles.option, this.props.checked ? styles.checked : styles.unchecked];

    return (
      <div className={classes.join(' ')} onClick={() => this.props.onClick()}>
        <div className={styles.icon}>
        {this.props.checked ?
          <Icon width={48} height={48} name={'icon-logo-' + this.props.value} colored={true} />:
          <Icon width={48} height={48} name={'icon-logo-' + this.props.value + '-disabled'} colored={true}/>
        }
        </div>
        {this.props.children}
      </div>
    );
  }
}

